<template>
  <div>
    <el-container>
      <el-header>
        <el-row type="flex" class="row-bg" justify="center">
          <el-dropdown trigger="click" @command="switchStation">
            <div
              style="
                color: rgb(191, 203, 217);
                font-weight: bold;
                font-size: large;
                line-height: 60px;
              "
            >
              {{ stationName }}
              <i class="el-icon-arrow-down el-icon--right"></i>
              <el-dropdown-menu class="station_dropdown" slot="dropdown">
                <el-row>
                  <div>
                    <el-input
                      v-model="stationNameSelectInput"
                      :placeholder="$t('siteMonitor.stationNameSelectInput')"
                    >
                      <i
                        slot="prefix"
                        class="el-input__icon el-icon-search"
                      ></i>
                    </el-input>
                  </div>
                </el-row>
                <el-dropdown-item> {{ $t('siteMonitor.all') }} </el-dropdown-item>
                <el-dropdown-item
                  v-for="site in stationsForSelectTemp"
                  :key="site.id"
                  :command="site.stationCode"
                >
                  {{ site.stationName }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </div>
          </el-dropdown>
        </el-row>
      </el-header>
      <el-main>
        <div class="div_two" style="padding-top: 20px">
          <el-row>
            <el-col :span="5">
              <el-row class="chargestate">
                <el-col>
                  <el-progress
                    type="circle"
                    :percentage="utilization"
                    :stroke-width="8"
                  >
                  </el-progress>
                  <h5>{{ $t('siteMonitor.MonthlyUtilizationRate') }}</h5>
                </el-col>
                <!--<div>-->
                <!--&lt;!&ndash;<h5>充电站概况</h5>&ndash;&gt;-->
                <!--<el-tag type="danger">快充：</el-tag>-->
                <!--<el-tag type="success">慢充：</el-tag>-->
                <!--</div>-->
              </el-row>
            </el-col>
            <el-col :span="14">
              <div>
                <!--<h5 class="h5_style">充电桩 ()</h5>-->
                <div>
                  <!--<el-row>-->
                  <!--<div class="div_style_one div_bule">-->
                  <!--<div class="fontStyle_three">-->
                  <!--<div class="fontStyle_one ">空闲</div>-->
                  <!--<div class="fontStyle_two">0</div>-->
                  <!--</div>-->
                  <!--</div>-->
                  <!--<div class="div_style_one div_bule">-->
                  <!--<div class="fontStyle_three">-->
                  <!--<div class="fontStyle_one">充电</div>-->
                  <!--<div class="fontStyle_two">0</div>-->
                  <!--</div>-->
                  <!--</div>-->
                  <!--<div class="div_style_one div_bule">-->
                  <!--<div class="fontStyle_three">-->
                  <!--<div class="fontStyle_one">离线</div>-->
                  <!--<div class="fontStyle_two">0</div>-->
                  <!--</div>-->
                  <!--</div>-->
                  <!--<div class="div_style_one div_bule">-->
                  <!--<div class="fontStyle_three">-->
                  <!--<div class="fontStyle_one">服务异常</div>-->
                  <!--<div class="fontStyle_two">0</div>-->
                  <!--</div>-->
                  <!--</div>-->
                  <!--</el-row>-->
                  <h5 class="h5_style">{{$t('siteMonitor.runningState')}}</h5>
                  <el-row>
                    <div class="div_style_zero div_green">
                      <div class="fontStyle_three">
                        <div class="fontStyle_one">{{$t('siteMonitor.runningState')}}</div>
                        <div class="fontStyle_two">
                          {{ stationGunHour.totalGunNum }}
                        </div>
                      </div>
                    </div>
                    <div class="div_style_zero div_green">
                      <div class="fontStyle_three">
                        <div class="fontStyle_one">{{$t('siteMonitor.Charging')}}</div>
                        <div class="fontStyle_two">
                          {{ stationGunHour.chargingGunNum }}
                        </div>
                      </div>
                    </div>
                    <div class="div_style_zero div_green">
                      <div class="fontStyle_three">
                        <div class="fontStyle_one">{{$t('siteMonitor.free')}}</div>
                        <div class="fontStyle_two">
                          {{ stationGunHour.freeGunNum }}
                        </div>
                      </div>
                    </div>
                    <div class="div_style_zero div_green">
                      <div class="fontStyle_three">
                        <div class="fontStyle_one">{{$t('siteMonitor.offline')}}</div>
                        <div class="fontStyle_two">
                          {{ stationGunHour.offlineGunNum }}
                        </div>
                      </div>
                    </div>
                    <div class="div_style_zero div_green">
                      <div class="fontStyle_three">
                        <div class="fontStyle_one">{{$t('siteMonitor.chargeFault')}}</div>
                        <div class="fontStyle_two">
                          {{ stationGunHour.badGunNum }}
                        </div>
                      </div>
                    </div>
                  </el-row>
                </div>
              </div>
            </el-col>
            <el-col :span="4">
              <el-row class="chargestate">
                <el-col>
                  <el-progress
                    type="circle"
                    :percentage="onlineRate || 0"
                    :stroke-width="8"
                  >
                  </el-progress>
                  <h5>{{$t('siteMonitor.OnlineRate')}}</h5>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </div>

        <el-row :gutter="14">
          <el-col :span="12">
            <div class="div_two div_margin">
              <div style="margin-left: 20px">
                <h5 class="h5_style">{{$t('siteMonitor.OnTheSameDay')}}</h5>
                <el-row>
                  <div class="div_style_one div_Orange">
                    <div class="fontStyle_three">
                      <div class="fontStyle_one">{{$t('siteMonitor.ChargingCapacity')}}</div>
                      <div class="fontStyle_two">
                        {{ currentDayOrder.totalElectricity }}
                      </div>
                    </div>
                  </div>
                  <div class="div_style_one div_Orange">
                    <div class="fontStyle_three">
                      <div class="fontStyle_one">{{$t('siteMonitor.ChargingIncome')}}</div>
                      <div class="fontStyle_two">
                        {{ currentDayOrder.totalFee }}
                      </div>
                    </div>
                  </div>
                  <div class="div_style_one div_Orange">
                    <div class="fontStyle_three">
                      <div class="fontStyle_one">{{$t('siteMonitor.serviceCharge')}}</div>
                      <div class="fontStyle_two">
                        {{ currentDayOrder.serviceFee }}
                      </div>
                    </div>
                  </div>
                  <div class="div_style_one div_Orange">
                    <div class="fontStyle_three">
                      <div class="fontStyle_one">{{$t('siteMonitor.ChargingOrder')}}</div>
                      <div class="fontStyle_two">
                        {{ currentDayOrder.orderNum }}
                      </div>
                    </div>
                  </div>
                </el-row>
                <h5 class="h5_style">{{$t('siteMonitor.CurrentMonth')}}</h5>
                <el-row>
                  <div class="div_style_one div_red">
                    <div class="fontStyle_three">
                      <div class="fontStyle_one">{{$t('siteMonitor.ChargingCapacity')}}</div>
                      <div class="fontStyle_two">
                        {{ currentMonthOrder.totalElectricity }}
                      </div>
                    </div>
                  </div>
                  <div class="div_style_one div_red">
                    <div class="fontStyle_three">
                      <div class="fontStyle_one">{{$t('siteMonitor.ChargingIncome')}}</div>
                      <div class="fontStyle_two">
                        {{ currentMonthOrder.totalFee }}
                      </div>
                    </div>
                  </div>
                  <div class="div_style_one div_red">
                    <div class="fontStyle_three">
                      <div class="fontStyle_one">{{$t('siteMonitor.serviceCharge')}}</div>
                      <div class="fontStyle_two">
                        {{ currentMonthOrder.serviceFee }}
                      </div>
                    </div>
                  </div>
                  <div class="div_style_one div_red">
                    <div class="fontStyle_three">
                      <div class="fontStyle_one">{{$t('siteMonitor.ChargingOrder')}}</div>
                      <div class="fontStyle_two">
                        {{ currentMonthOrder.orderNum }}
                      </div>
                    </div>
                  </div>
                </el-row>
                <h5 class="h5_style">{{$t('siteMonitor.BackThen')}}</h5>
                <el-row>
                  <div class="div_style_one div_bule">
                    <div class="fontStyle_three">
                      <div class="fontStyle_one">{{$t('siteMonitor.ChargingCapacity')}}</div>
                      <div class="fontStyle_two">
                        {{ currentYearOrder.totalElectricity }}
                      </div>
                    </div>
                  </div>
                  <div class="div_style_one div_bule">
                    <div class="fontStyle_three">
                      <div class="fontStyle_one">{{$t('siteMonitor.ChargingIncome')}}</div>
                      <div class="fontStyle_two">
                        {{ currentYearOrder.totalFee }}
                      </div>
                    </div>
                  </div>
                  <div class="div_style_one div_bule">
                    <div class="fontStyle_three">
                      <div class="fontStyle_one">{{$t('siteMonitor.serviceCharge')}}</div>
                      <div class="fontStyle_two">
                        {{ currentYearOrder.serviceFee }}
                      </div>
                    </div>
                  </div>
                  <div class="div_style_one div_bule">
                    <div class="fontStyle_three">
                      <div class="fontStyle_one">{{$t('siteMonitor.ChargingOrder')}}</div>
                      <div class="fontStyle_two">
                        {{ currentYearOrder.orderNum }}
                      </div>
                    </div>
                  </div>
                </el-row>
                <h5 class="h5_style">{{$t('siteMonitor.Cumulative')}}</h5>
                <el-row>
                  <div class="div_style_one div_green">
                    <div class="fontStyle_three">
                      <div class="fontStyle_one">{{$t('siteMonitor.ChargingCapacity')}}</div>
                      <div class="fontStyle_two">
                        {{ totalOrder.totalElectricity }}
                      </div>
                    </div>
                  </div>
                  <div class="div_style_one div_green">
                    <div class="fontStyle_three">
                      <div class="fontStyle_one">{{$t('siteMonitor.ChargingIncome')}}</div>
                      <div class="fontStyle_two">{{ totalOrder.totalFee }}</div>
                    </div>
                  </div>
                  <div class="div_style_one div_green">
                    <div class="fontStyle_three">
                      <div class="fontStyle_one">{{$t('siteMonitor.serviceCharge')}}</div>
                      <div class="fontStyle_two">
                        {{ totalOrder.serviceFee }}
                      </div>
                    </div>
                  </div>
                  <div class="div_style_one div_green">
                    <div class="fontStyle_three">
                      <div class="fontStyle_one">{{$t('siteMonitor.ChargingOrder')}}</div>
                      <div class="fontStyle_two">{{ totalOrder.orderNum }}</div>
                    </div>
                  </div>
                </el-row>
              </div>
            </div>
            <!--<el-row :gutter="14"><el-col :span="24"><div class="div_two div_margin"></div></el-col></el-row>-->
          </el-col>

          <!--尖峰平谷-->
          <el-col :span="12">
            <div class="div_two">
              <div class="st-gbox" style="height: 35vh">
                <div class="cavasbox" id="IncomeEchart"></div>
              </div>
            </div>

            <!--收入曲线分布图-->
            <el-row :gutter="14">
              <el-col :span="24">
                <div class="div_two div_margin">
                  <div class="st-gbox" style="height: 35vh">
                    <div class="cavasbox" id="ChargeIncomeEchart"></div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <!--<el-row :gutter="44">
          <el-col :span="24">
            <div class="div_two div_margin">
              <h3 class="h5_style">充电站收入分布图</h3>
              <div class="st-gbox">
                <div class="cavasbox" id="StationEchart"></div>
              </div>
            </div>
          </el-col>
        </el-row>-->

        <!--营业额/充电量-->
        <el-row :gutter="14">
          <el-col :span="24">
            <div class="div_two div_margin">
              <h5 class="h5_style">{{ $t('siteMonitor.EchartTitle1') }}</h5>
              <div class="st-gbox" style="height: 45vh">
                <div class="cavasbox" id="PersonalEchart"></div>
              </div>
            </div>
          </el-col>
        </el-row>

        <el-row style="margin-top: 20px">
          <h5 class="h5_style">{{ $t('siteMonitor.EchartTitle2') }}</h5>
          <el-table
            :data="table.views"
            highlight-current-row
            v-loading="table.loading"
            border
            :element-loading-text="$t('siteMonitor.Loading')"
            style="width: 100%"
          >
            <af-table-column
              prop="stationName"
              :label="$t('siteMonitor.stationName')"
            ></af-table-column>
            <af-table-column prop="pileCode" :label="$t('siteMonitor.pileCode')"></af-table-column>
            <af-table-column prop="gunCode" :label="$t('siteMonitor.gunCode')"></af-table-column>
            <af-table-column
              prop="totalElectricQuantity"
              :label="$t('siteMonitor.totalElectricQuantity')"
            ></af-table-column>
            <af-table-column
              prop="totalChargeTime"
              :label="$t('siteMonitor.totalChargeTime')"
            ></af-table-column>
            <af-table-column
              prop="totalFee"
              :label="$t('siteMonitor.totalFee')"
            ></af-table-column>
            <af-table-column
              prop="totalElectricFee"
              :label="$t('siteMonitor.totalElectricFee')"
            ></af-table-column>
            <af-table-column
              prop="totalServiceFee"
              :label="$t('siteMonitor.totalServiceFee')"
            ></af-table-column>
            <af-table-column
              prop="usedRate"
              :label="$t('siteMonitor.usedRate')"
            ></af-table-column>
            <af-table-column prop="batchTime" :label="$t('siteMonitor.batchTime')"></af-table-column>
          </el-table>
          <!-- 分页组件 add by shikai-->
          <Pagination
            v-bind:child-msg="table.pageparm"
            @callFather="changePage"
          ></Pagination>
        </el-row>
      </el-main>
    </el-container>
  </div>
</template>

<script type="text/ecmascript-6">
import Pagination from "../../../components/Pagination";
import Chart from "echarts";
import siteMonitorApi from "../../operatingCenter/api/siteMonitorApi";

export default {
  name: "siteMonitor",
  data() {
    return {
      currentDayOrder: {},
      currentMonthOrder: {},
      currentYearOrder: {},
      totalOrder: {},
      dailyOrderList: {},
      dailyStationGroupList: {},
      dailyStationOrderList: {},
      stationGunHour: {},
      pileOrdeMonthly: [],
      utilization: 0,
      onlineRate: 0,
      stationsForSelect: [],
      stationsForSelectTemp: [],
      stationName: this.$t('siteMonitor.all'),
      stationNameSelectInput: "",
      table: {
        loading: false,
        views: [],
        pageparm: {
          // 分页参数
          t: {
            stationCode: "",
          },
          currentPage: 1,
          pageSize: 10,
          total: 0,
        },
      },
    };
  },
  // 里面的函数只有调用才会执行
  methods: {
    getChargeIncome() {
      let dayData = [];
      let dayTotalElectricity = [];
      let dayTotalFee = [];
      let dayTotalElectricFee = [];
      let dayServiceFee = [];
      let dayOrderNum = [];
      for (let index in this.dailyStationOrderList) {
        dayData[index] = this.dailyStationOrderList[index].batchTime;
        dayTotalElectricity[index] = this.dailyStationOrderList[
          index
        ].totalElectricQuantity;
        dayTotalFee[index] = this.dailyStationOrderList[index].totalFee;
        dayTotalElectricFee[index] = this.dailyStationOrderList[
          index
        ].totalElectricFee;
        dayServiceFee[index] = this.dailyStationOrderList[
          index
        ].totalServiceFee;
        dayOrderNum[index] = this.dailyStationOrderList[index].totalOrderNumber;
      }
      this.chart = Chart.init(document.getElementById("ChargeIncomeEchart"));
      this.chart.setOption({
        title: {
          text: this.$t('siteMonitor.ChargingDistribution'),
        },
        tooltip: {
          trigger: "axis",
          extraCssText:'text-align:left',
        },
        legend: {
          data: [
            this.$t('siteMonitor.ChargingCapacity2'),
            this.$t('siteMonitor.turnover'),
            this.$t('siteMonitor.ElectricityBill'),
            this.$t('siteMonitor.serviceCharge2'),
            this.$t('siteMonitor.OrderQuantity')],
          top: 1,
          left: 200,
          itemGap: 10,
          itemWidth: 12,
          itemHeight: 12,
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          axisLabel: {
            interval: 0,
            rotate: 30,
          },
          data: dayData,
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            name: this.$t('siteMonitor.ChargingCapacity2'),
            type: "line",
            stack: this.$t('siteMonitor.total'),
            data: dayTotalElectricity,
          },
          {
            name: this.$t('siteMonitor.turnover'),
            type: "line",
            stack: this.$t('siteMonitor.total'),
            data: dayTotalFee,
          },
          {
            name: this.$t('siteMonitor.ElectricityBill'),
            type: "line",
            stack: this.$t('siteMonitor.total'),
            data: dayTotalElectricFee,
          },
          {
            name: this.$t('siteMonitor.serviceCharge2'),
            type: "line",
            stack: this.$t('siteMonitor.total'),
            data: dayServiceFee,
          },
          {
            name: this.$t('siteMonitor.OrderQuantity'),
            type: "line",
            stack: this.$t('siteMonitor.total'),
            data: dayOrderNum,
          },
        ],
      });
    },
    //尖峰平谷
    getIncomeEchart() {
      let totalSharpElectricity = this.currentMonthOrder.totalSharpElectricity;
      let totalPeakElectricity = this.currentMonthOrder.totalPeakElectricity;
      let totalFlatElectricity = this.currentMonthOrder.totalFlatElectricity;
      let totalValleyElectricity = this.currentMonthOrder
        .totalValleyElectricity;
      let totalSharpFee = this.currentMonthOrder.totalSharpFee;
      let totalPeakFee = this.currentMonthOrder.totalPeakFee;
      let totalFlatFee = this.currentMonthOrder.totalFlatFee;
      let totalValleyFee = this.currentMonthOrder.totalValleyFee;

      this.chart = Chart.init(document.getElementById("IncomeEchart"));
      this.chart.setOption({
        title: {
          text: this.$t('siteMonitor.MonthlyStatistics'),
        },
        tooltip: {
          trigger: "item",
          // formatter: "{a} <br/>{b}: {c} ({d}%)",
        },
        legend: {
          orient: "vertical",
          x: "left",
          top: "13%",
          data: [
            this.$t('siteMonitor.tip'),
            this.$t('siteMonitor.peak'),
            this.$t('siteMonitor.flat'),
            this.$t('siteMonitor.valley')],
        },
        series: [
          {
            name:this.$t('siteMonitor.ChargingIncome2'),
            type: "pie",
            selectedMode: "single",
            radius: [0, "30%"],

            label: {
              normal: {
                position: "inner",
              },
            },
            labelLine: {
              normal: {
                show: false,
              },
            },
            data: [
              {
                value: totalSharpFee,
                name: this.$t('siteMonitor.tip'),
                selected: true,
                itemStyle: {
                  color: "#ff4d4d",
                },
              },
              {
                value: totalPeakFee,
                name: this.$t('siteMonitor.peak'),
                itemStyle: {
                  color: "#ffbc2e",
                },
              },
              {
                value: totalFlatFee,
                name: this.$t('siteMonitor.flat'),
                itemStyle: {
                  color: "#43c26e",
                },
              },
              {
                value: totalValleyFee,
                name: this.$t('siteMonitor.valley'),
                itemStyle: {
                  color: "#409eff",
                },
              },
            ],
          },
          {
            name: this.$t('siteMonitor.ChargingCapacity2'),
            type: "pie",
            radius: ["40%", "55%"],
            label: {
              normal: {
                formatter: "{a|{a}}{abg|}\n{hr|}\n  {b|{b}：}{c}  {per|{d}%}  ",
                backgroundColor: "#eee",
                borderColor: "#aaa",
                borderWidth: 1,
                borderRadius: 4,
                // shadowBlur:3,
                // shadowOffsetX: 2,
                // shadowOffsetY: 2,
                // shadowColor: '#999',
                // padding: [0, 7],
                rich: {
                  a: {
                    color: "#999",
                    lineHeight: 22,
                    align: "center",
                  },
                  // abg: {
                  //     backgroundColor: '#333',
                  //     width: '100%',
                  //     align: 'right',
                  //     height: 22,
                  //     borderRadius: [4, 4, 0, 0]
                  // },
                  hr: {
                    borderColor: "#aaa",
                    width: "100%",
                    borderWidth: 0.5,
                    height: 0,
                  },
                  b: {
                    fontSize: 16,
                    lineHeight: 33,
                  },
                  per: {
                    color: "#eee",
                    backgroundColor: "#334455",
                    padding: [2, 4],
                    borderRadius: 2,
                  },
                },
              },
            },
            data: [
              {
                value: totalSharpElectricity,
                name: this.$t('siteMonitor.tip'),
                itemStyle: {
                  color: "#ff4d4d",
                },
              },
              {
                value: totalPeakElectricity,
                name: this.$t('siteMonitor.peak'),
                itemStyle: {
                  color: "#ffbc2e",
                },
              },
              {
                value: totalFlatElectricity,
                name: this.$t('siteMonitor.flat'),
                itemStyle: {
                  color: "#43c26e",
                },
              },
              {
                value: totalValleyElectricity,
                name: this.$t('siteMonitor.valley'),
                itemStyle: {
                  color: "#409eff",
                },
              },
            ],
          },
        ],
      });
    },
    // 电站的收入/电量柱状图
    /*getPileOrder () {
			  let pileOrder = this.pileOrdeMonthly
			  let yDate = []
			  let electricityDate = []
			  let feeDate = []
			  for (let i=0;i<pileOrder.length;i++) {
			    yDate[i] = pileOrder[i].pileCode
			    electricityDate[i] = pileOrder[i].totalElectricity
			    feeDate[i] = pileOrder[i].totalFee
			  }
			  console.log(yDate)
			  this.chart = Chart.init(document.getElementById("StationEchart"))
			  this.chart.setOption({
			    tooltip : {
			      trigger: 'axis',
			      axisPointer : {            // 坐标轴指示器，坐标轴触发有效
			        type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
			      }
			    },
			    legend: {
			      data: ['收入', '充电量']
			    },
			    grid: {
			      left: '3%',
			      right: '4%',
			      bottom: '3%',
			      containLabel: true
			    },
			    xAxis:  {
			      type: 'value'
			    },
			    yAxis: {
			      type: 'category',
			      data: yDate
			    },
			    series: [
			      {
			        name: '收入',
			        type: 'bar',
			        stack: '总量',
			        label: {
			          normal: {
			            show: false,
			            position: 'insideRight'
			          }
			        },
			        data: feeDate
			      },
			      {
			        name: '充电量',
			        type: 'bar',
			        stack: '总量',
			        label: {
			          normal: {
			            show: false,
			            position: 'insideRight'
			          }
			        },
			        data: electricityDate
			      }
			    ]
			  })
			},*/
    getPersonal() {
      let dayData = [];
      let totalElectricityGroup = [];
      let totalFeeGroup = [];
      let totalFeeCustomer = [];
      let totalElectricityCustomer = [];
      for (let index in this.dailyStationGroupList) {
        dayData[index] = this.dailyStationGroupList[index].batchTime;
        totalElectricityGroup[index] = this.dailyStationGroupList[
          index
        ].groupElectricQuantity;
        totalFeeGroup[index] = this.dailyStationGroupList[index].groupFee;
        totalElectricityCustomer[index] = this.dailyStationGroupList[
          index
        ].stationElectricQuantity;
        totalFeeCustomer[index] = this.dailyStationGroupList[index].stationFee;
      }
      this.chart = Chart.init(document.getElementById("PersonalEchart"));
      this.chart.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "line", // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        legend: {
          data: [
            this.$t('siteMonitor.TotalTurnover'),
          this.$t('siteMonitor.TotalChargingCapacity'),
          this.$t('siteMonitor.GroupRevenue'),
          this.$t('siteMonitor.GroupChargingCapacity')],
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },

        xAxis: [
          {
            type: "category",
            axisLine: {
              lineStyle: {
                color: "#90979c",
              },
            },
            splitLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            splitArea: {
              show: false,
            },
            axisLabel: {
              interval: 0,
              rotate: 30,
            },
            data: dayData,
          },
        ],
        yAxis: [
          {
            type: "value",
          },
        ],
        series: [
          {
            name: this.$t('siteMonitor.TotalTurnover'),
            type: "bar",
            stack: this.$t('siteMonitor.TotalTurnover'),
            label: {
              normal: {
                show: false,
                position: "insideRight",
              },
            },
            itemStyle: {
              color: new Chart.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#ff7d56" },
                { offset: 0.5, color: "#ff608d" },
                { offset: 1, color: "#ff608d" },
              ]),
            },
            data: totalFeeCustomer,
          },
          {
            name: this.$t('siteMonitor.TotalChargingCapacity'),
            type: "bar",
            stack: this.$t('siteMonitor.TotalChargingCapacity'),
            label: {
              normal: {
                show: false,
                position: "insideRight",
              },
            },
            itemStyle: {
              color: new Chart.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#5aafff" },
                { offset: 0.5, color: "#5175fe" },
                { offset: 1, color: "#5175fe" },
              ]),
            },
            data: totalElectricityCustomer,
          },
          {
            name: this.$t('siteMonitor.GroupRevenue'),
            type: "bar",
            stack: this.$t('siteMonitor.GroupRevenue'),
            label: {
              normal: {
                show: false,
                position: "insideRight",
              },
            },
            itemStyle: {
              color: new Chart.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#eb70e9 " },
                { offset: 0.5, color: "#8c64f7" },
                { offset: 1, color: "#8c64f7" },
              ]),
            },
            data: totalFeeGroup,
          },
          {
            name: this.$t('siteMonitor.GroupChargingCapacity'),
            type: "bar",
            stack: this.$t('siteMonitor.GroupChargingCapacity'),
            label: {
              normal: {
                show: false,
                position: "insideRight",
              },
            },
            itemStyle: {
              color: new Chart.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#22cab8 " },
                { offset: 0.5, color: "#179fcf" },
                { offset: 1, color: "#179fcf" },
              ]),
            },
            data: totalElectricityGroup,
          },
        ],
      });
    },
    // 加载下拉框
    loadSelectItem() {
      siteMonitorApi
        .getStations(this.$store.getters.operatorIds)
        .then((res) => {
          if (res.code == 0) this.stationsForSelect = res.data;
          this.stationsForSelectTemp = res.data.slice(0);
        });
    },
    async switchStation(command, event) {
      await this.getStationGun(command);
      this.getStationOrder(command);
      this.getDailyGunStatistics(command);
      this.stationName = event.$el.innerText;
    },
    changePage() {
      //查询表格分页
      this.getDailyGunStatistics();
    },
    getDailyGunStatistics(param) {
      this.table.listLoading = true;
      if (param) {
        this.table.pageparm.t.stationCode = param;
      }
      let json = JSON.stringify(this.table.pageparm);
      siteMonitorApi.getDailyGunStatistics(json).then((res) => {
        console.log(res);
        if (res.code === 0) {
          console.log("getDailyGunStatistics::", res);
          for (let i in res.data.list) {
            let minute = res.data.list[i].totalChargeTime / 60;
            let second = res.data.list[i].totalChargeTime % 60;
            let totalChargeTime = parseInt(minute) + ":" + second;
            res.data.list[i].totalChargeTime = totalChargeTime;
          }
          this.table.views = res.data.list;
          this.table.pageparm.total = res.data.total;
        }
        this.table.loading = false;
      });
    },
    getStationOrder(param) {
      siteMonitorApi.getStationOrder(param).then((res) => {
        if (res) {
          this.currentDayOrder = res.currentDayOrder;
          this.currentMonthOrder = res.currentMonthOrder;
          this.currentYearOrder = res.currentYearOrder;
          this.totalOrder = res.totalOrder;
          this.dailyOrderList = res.dailyOrderList;
          this.dailyStationGroupList = res.dailyStationGroupList;
          this.dailyStationOrderList = res.dailyStationOrderList;
          //this.pileOrdeMonthly = res.pileOrdeMonthly
          // 用户费率/(空闲+充电中)
          if (
            this.stationGunHour.chargingGunNum + this.stationGunHour.freeGunNum
          ) {
            this.utilization =
              Math.round(
                (res.userRate /
                  (this.stationGunHour.chargingGunNum +
                    this.stationGunHour.freeGunNum)) *
                  100
              ) / 100;
          } else {
            this.utilization = 0;
          }
        } else {
        }
      });
    },
    getStationGun(param) {
      siteMonitorApi.getStationGun(param).then((res) => {
        if (res) {
          this.stationGunHour = res.stationGunHour;
          //this.utilization = res.utilization
          this.onlineRate = res.onlineRate;
        } else {
          this.$message.error(this.$t('siteMonitor.error'));
        }
      });
    },
  },
  // 导入组件
  components: {
    Pagination,
  },
  // 创建完毕状态(里面是操作)
  created() {},
  // 挂载结束状态(里面是操作)
  watch: {
    stationNameSelectInput: function (val, oldVal) {
      if (val.length <= 0) {
        this.stationsForSelectTemp = this.stationsForSelect.slice(0, 10);
      } else {
        this.stationsForSelectTemp = [];
        this.stationsForSelect.forEach((item, index) => {
          if (item.stationName.indexOf(val) >= 0) {
            if (this.stationsForSelectTemp.length < 10) {
              this.stationsForSelectTemp.push(item);
            }
          }
        });
      }
    },
  },
  async mounted() {
    this.loadSelectItem();
    await this.getStationGun();
    this.getStationOrder();
    this.getDailyGunStatistics();
  },
  beforeUpdate() {
    this.getChargeIncome();
    this.getIncomeEchart();
    this.getPersonal();
    //this.getPileOrder()
  },
};
</script>

<style scoped>
.div_margin {
  margin-top: 20px;
  padding-bottom: 10px;
}

.div_two {
  background-color: white;
}

.h5_style {
  text-align: left;
  margin: 0px 0px 10px 5px;
  padding-top: 10px;
}

.div_style_one {
  float: left;
  width: 24%;
  height: 60px;
  padding: 10px 0;
  margin: 0px 5px 5px 0px;
}

.div_style_zero {
  float: left;
  width: 18%;
  height: 60px;
  margin: 0px 10px 10px 0px;
}

.div_Orange {
  background-color: #ffbc2e;
}

.div_red {
  background-color: #ff6640;
}

.div_bule {
  background-color: #409eff;
}

.div_green {
  background-color: #43c26e;
}

.fontStyle_three {
  margin: 10px 20px 0px 20px;
}

.fontStyle_one {
  color: white;
  font-size: small;
}

.fontStyle_two {
  color: white;
  font-size: 16px;
  margin-top: 5px;
}

.fontStyle_four {
  font-size: small;
}

.fontStyle_five {
  font-size: 20px;
  margin-top: 5px;
}

.el-header {
  color: #c0c4cc;
  text-align: center;
  background-color: #364140;
  height: 60px !important;
  line-height: 60px;
  padding: 0 10px;
}

.el-main {
  background-color: #f0f9eb;
  color: #333;
  text-align: center;
}

.bg-purple {
  background: #d3dce6;
}

.bg-purple-light {
  background: #e5e9f2;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

.chargestate {
  padding-top: -120px;
}

.st-gbox {
  /*background-color: #fff;*/
  margin-top: 20px;
  border-radius: 5px;
  height: 30vh;
  box-sizing: border-box;
  padding: 10px;
}

.cavasbox {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
}

/*.el-row {*/
/*margin-bottom: 4px;*/
/*&:last-child {*/
/*margin-bottom: 0;*/
/*}*/
/*}*/
.grid-content {
  border-radius: 2px;
  min-height: 28px;
  line-height: 28px;
  text-align: left;
  font-size: small;
  color: #606266;
  padding-left: 10px;
}

/deep/ .el-dropdown-menu {
  max-height: 200px;
  overflow-y: auto;
}

/* /deep/ .el-header {
  height: 60px !important;
  line-height: 60px;
  padding: 0 10px;
} */

.station_dropdown {
  max-height: 450px;
  overflow: auto;
  padding: 10px 20px !important;
}
</style>



// WEBPACK FOOTER //
// src/module/operatingCenter/page/siteMonitor.vue